import React from 'react';
import classes from './Partners.module.scss';

import A from 'components/atoms/A/A';
import { PRIVACY_NOTICE } from 'components/pages/pages';
import awinLogo from './partnerLogos/awin.png';
import cintLogo from './partnerLogos/cint.png';
import affiliateLogo from './partnerLogos/cj-affiliate.png';
import dynataLogo from './partnerLogos/dynata-logo.png';
import flexoffersLogo from './partnerLogos/flexoffers.png';
import quratedLogo from './partnerLogos/logo_qurated.png';
import lucidLogo from './partnerLogos/lucid.png';
import maxbountyLogo from './partnerLogos/maxbounty.png';
import pollfishLogo from './partnerLogos/pollfish.png';
import tolunaLogo from './partnerLogos/toluna.png';
import Txt from 'components/atoms/Txt/Txt';
import Image from 'components/atoms/Image/Image';
import Card from 'components/atoms/Card/Card';
import Heading from 'components/atoms/Heading/Heading';

export interface Props {}

const Partners: React.FC<Props> = () => {
  return (
    <div className={classes.root}>
      <div>
        <Heading heading={1} className={classes.title}>
          Our Partners
        </Heading>
        <Txt component="p">
          Here are some of the partners we work with, and a link to their respective data policies.
          See our{' '}
          <Txt component={A} target="_blank" href={PRIVACY_NOTICE.path}>
            Privacy Notice
          </Txt>{' '}
          to see how we share your data with our partners.
        </Txt>
      </div>
      <section className={classes.partners}>
        <Card
          className={classes.partnerItem}
          component={A}
          target="_blank"
          href="https://luc.id/legal/privacy-policy/"
        >
          <Image src={lucidLogo} alt="Lucid Logo" width={158} height={158} />
        </Card>
        <Card
          className={classes.partnerItem}
          component={A}
          target="_blank"
          href="https://uk.toluna.com/Privacy"
        >
          <Image src={tolunaLogo} alt="Toluna Logo" />
        </Card>
        <Card
          className={classes.partnerItem}
          component={A}
          target="_blank"
          href="https://www.cint.com/participant-privacy-notice"
        >
          <Image src={cintLogo} alt="Cint Logo" />
        </Card>
        <Card
          className={classes.partnerItem}
          component={A}
          target="_blank"
          href="https://www.dynata.com/privacy-policy/"
        >
          <Image src={dynataLogo} alt="Dynata Logo" />
        </Card>
        <Card
          className={classes.partnerItem}
          component={A}
          target="_blank"
          href="https://www.awin.com/us/terms-and-conditions/publisher-terms-and-conditions-2018"
        >
          <Image src={awinLogo} alt="Awin Logo" />
        </Card>
        <Card
          className={classes.partnerItem}
          component={A}
          target="_blank"
          href="https://www.pollfish.com/terms/respondent"
        >
          <Image src={pollfishLogo} alt="Pollfish Logo" />
        </Card>
        <Card
          className={classes.partnerItem}
          component={A}
          target="_blank"
          href="https://www.conversantmedia.com/legal/privacy"
        >
          <Image src={affiliateLogo} alt="Conversant Logo" />
        </Card>
        <Card
          className={classes.partnerItem}
          component={A}
          target="_blank"
          href="https://www.flexoffers.com/privacy-policy/"
        >
          <Image src={flexoffersLogo} alt="Flexoffers Logo" />
        </Card>
        <Card
          className={classes.partnerItem}
          component={A}
          target="_blank"
          href="https://www.maxbounty.com/"
        >
          <Image src={maxbountyLogo} alt="Max Bounty Logo" />
        </Card>
        <Card
          className={classes.partnerItem}
          component={A}
          target="_blank"
          href="https://www.qurated.ai/"
        >
          <Image src={quratedLogo} alt="Qurated Logo" />
        </Card>
      </section>
      <div>
        <Heading level={2} className={classes.title}>
          Contact Us
        </Heading>
        <Txt component="p">
          If you are interested in finding out how partnering with Qmee can help your business reach
          more customers, please contact us at{' '}
          <A className={classes.contactLink} href="mailto:partners@qmee.com">
            partners@qmee.com
          </A>
          .
        </Txt>
      </div>
    </div>
  );
};
export default Partners;
